export default class Common {

    handleScroll() {
        let pageBody = document.body;

        function checkIfScrolled() {
            if (pageBody && window.scrollY >= 20) {
                pageBody.classList.add('scrolled');
            } else {
                pageBody.classList.remove('scrolled');
            }
        }

        window.addEventListener('scroll', checkIfScrolled);

        // Initial check to apply the class if the page is already scrolled
        checkIfScrolled();
    }


    scrollToContentOfHashKeyword() {
        const bookNowLinks = document.querySelectorAll('a[href="#bookNow"]');
        const bookNowButtons = document.querySelectorAll('button[data-attr="#bookNow"]');
        const bookNowEl = document.querySelector('#bookNow');

        const handleScroll = (e, target) => {
            e.preventDefault();
            e.stopPropagation();

            let clientRoomsSelect = document.querySelector('#client-rooms');
            if (clientRoomsSelect && e.target.closest(".accommodation")) {
                let accommodationId = e.target.closest(".accommodation").getAttribute('id').replace('_', ' ');
                clientRoomsSelect.value = accommodationId.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            }

            this.scrollToEl(bookNowEl);
        };

        if (bookNowEl) {
            bookNowLinks.forEach((link) => {
                link.addEventListener('click', (e) => handleScroll(e, link));
            });

            bookNowButtons.forEach((button) => {
                button.addEventListener('click', (e) => handleScroll(e, button));
            });
        }
    }


    scrollToHash() {
        const hash = window.location.hash.substring(1); // Remove the '#' from the hash.

        if (hash) {
            const targetEl = document.querySelector('.' + hash); // Get the target element by ID

            // If the target element exists, scroll to it
            if (targetEl) {
                this.scrollToEl(targetEl);
            }
        }
    }

    scrollToEl(el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 100;

        window.scroll({
            top: y,
            behavior: 'smooth'
        });
    }


    backToTopButton() {
        // Adding click event listener to the back-to-top button
        document.querySelector("#backTop a").addEventListener("click", function (event) {
            event.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

        // Adding scroll event listener to the window
        window.addEventListener("scroll", function () {
            let scroll = window.scrollY;
            let backTop = document.getElementById("backTop");
            if (scroll >= 100) {
                backTop.classList.add('show');
            } else {
                backTop.classList.remove("show");
            }
        });

    }


    init() {
        this.handleScroll()
        this.scrollToContentOfHashKeyword()
        this.scrollToHash()
        this.backToTopButton()
    }
}
